import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { userService } from "../../services/UserService";
import Skeleton from "@mui/material/Skeleton";
import { useHistory } from "react-router-dom";

function InterestedUsersForOffres() {
  const [t] = useTranslation();
  const history = useHistory();
  const [interastedUserCountList, setInterastedUserCountList] = useState<any>(
    []
  );
  const [chartSeriesList, setChartSeriesList] = useState<any>([]);
  const [chartLabelsList, setChartLabelsList] = useState<any>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [modalType, setModalType] = useState<string>("error");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    getIterastedUserCount();
  }, []);

  const handleModelClose = () => setShowModal(false);

  const getIterastedUserCount = async () => {
    const seriesList: any = [];
    const labelsList: any = [];
    setIsLoading(true);
    const res = await userService.getInterastedUserCountForOffer();
    if (res && res.length > 0) {
      setInterastedUserCountList(res);
      res.forEach((item: any) => {
        labelsList.push(item.title);
        seriesList.push(item.userCount);
      });
      setChartLabelsList(labelsList);
      setChartSeriesList(seriesList);
    } else {
      setModalType("error");
      setModalText(t("Something went wrong!"));
      setShowModal(true);
    }
    setIsLoading(false);
  };

  const stateOptions: any = {
    series: chartSeriesList,
    options: {
      chart: {
        width: 380,
        type: "pie",
        events: {
          dataPointSelection: (event: any, chartContext: any, config: any) => {
            const seriesName = config.w.globals.labels[config.dataPointIndex];
            const seriesCount = config.w.globals.series[config.dataPointIndex];
            const offer = interastedUserCountList.find(
              (item: any, index: any) => index === config.dataPointIndex
            );
            handleChartClick(offer);
          },
        },
      },
      labels: chartLabelsList,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
      dataLabels: {
        formatter: function (val: any, opts: any) {
          return opts.w.config.series[opts.seriesIndex];
        },
      },
      fill: {
        colors: [
          "#198754c7",
          "#0dcaf0c7",
          "#ffc107c7",
          "#19875480",
          "#0dcaf080",
          "#ffc10780",
          "#19875436",
          "#0dcaf036",
          "#ffc10736",
        ],
      },
    },
  };

  const handleChartClick = (offer: any) => {
    if (offer) {
      history.push({
        pathname: "/auth/interestedusers",
        state: { offerId: offer.offerId, offerName: offer.title },
      });
    }
  };

  return (
    <>
      <div className="card border-0 shadow-sm rounded-1rem">
        <div className="card-body p-4">
          <h6 className="fw-bold text-primary">
            {t("Interested Users For Offers")}
          </h6>
          {interastedUserCountList && interastedUserCountList.length > 0 ? (
            <div className="text-center">
              {isLoading ? (
                <Skeleton
                  variant="circular"
                  width={300}
                  height={300}
                  className="d-inline-block"
                />
              ) : (
                <ReactApexChart
                  options={stateOptions.options}
                  series={stateOptions.series}
                  type="pie"
                  width={450}
                  className="d-inline-block"
                />
              )}
            </div>
          ) : (
            <div className="text-center text-999 m-3 p-3">
              <i className="material-icons-outlined fs-1 me-2">info</i>
              <p className="fs-6">{t("No data found")}</p>
            </div>
          )}
        </div>
      </div>
      {modalType === "error" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleModelClose}
        >
          <Alert onClose={handleModelClose} severity="error">
            {modalText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default InterestedUsersForOffres;
